angular.module('Itao.IndicatorMap').directive('addWidget', function ($rootScope) {
  'use strict';
  var addEventName = 'createNewWidget';

  return {
    restrict: 'A',
    scope: {
      'addWidget': '@'
    },
    link: function(scope, element){
      element.on('click', function() {
        $rootScope.$broadcast(addEventName, {
          type: scope.addWidget
        });
      });
    }
  };
});
